/**
 * The type of (redux) action which sets the visibility of the audio settings popup.
 */
export const SET_AUDIO_SETTINGS_VISIBILITY = 'SET_AUDIO_SETTINGS_VISIBILITY';
export const SET_SETTINGS = 'SET_BASE_SETTINGS';
export const OPEN_SETTINGS = 'OPEN_SETTINGS';
export const OPEN_GROUPS = 'OPEN_GROUPS';
export const SET_VIDEO_ONLY = 'SET_VIDEO_ONLY';

/**
 * The type of (redux) action which sets the visibility of the video settings popup.
 */
export const SET_VIDEO_SETTINGS_VISIBILITY = 'SET_VIDEO_SETTINGS_VISIBILITY';
